exports = module.exports = require("../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".ButtonGroup__root___1NYTe {\n  display: inline-block;\n  vertical-align: top;\n  margin: 0 5px 5px 0;\n  white-space: nowrap;\n}\n\n.ButtonGroup__root___1NYTe:last-child {\n  margin-right: 0;\n}\n\n/* TODO: remove all this child selector and tag selector stuff. */\n\n.ButtonGroup__root___1NYTe > div > button {\n  margin-right: 0;\n  border-radius: 0;\n}\n\n.ButtonGroup__root___1NYTe > div > button:focus {\n  position: relative;\n  z-index: 1;\n}\n\n.ButtonGroup__root___1NYTe > div:first-child > button {\n  border-top-left-radius: 2px;\n  border-bottom-left-radius: 2px;\n}\n\n.ButtonGroup__root___1NYTe > div + div > button {\n  border-left-width: 0;\n}\n\n.ButtonGroup__root___1NYTe > div:last-child > button {\n  border-top-right-radius: 2px;\n  border-bottom-right-radius: 2px;\n}\n", ""]);

// Exports
exports.locals = {
	"root": "ButtonGroup__root___1NYTe"
};


//////////////////
// WEBPACK FOOTER
// ../css-loader/dist/cjs.js??ref--2-1!../react-rte/lib/ui/ButtonGroup.css
// module id = 2161
// module chunks = 25